import { useState } from "react"
import { createPortal } from "react-dom"
import parse from "html-react-parser"

import Modal from "shared/components/modal"
import { updateSubscriptionPlan } from "app/components/upgrade_plan_modal/pro_upgrade/api"

import { lockupLogoSvg } from "shared/utils/ifttt_logo"
import { planNameBadge } from "shared/utils/tiers"

import styles from "app/components/upgrade_plan_modal/shared_modal.module.scss"

interface Props {
  productId: string
  planName: string
  cta: string
  priceLine?: string
  onClose: () => void
  onSwitched: () => void
}

// Switches an existing Stripe credits subscription to another credits plan in place.
const CreditsPlanChangeModal = ({ productId, planName, cta, priceLine, onClose, onSwitched }: Props) => {
  const [loading, setLoading] = useState(false)

  const handleSwitch = async () => {
    setLoading(true)

    try {
      const { errors } = await updateSubscriptionPlan({ productId })

      if (!errors?.length) {
        onSwitched()
      } else {
        window.appendFlash(errors[0]?.message || "Something went wrong. Please try again.", "danger")
        onClose()
      }
    } catch {
      window.appendFlash("Something went wrong. Please try again.", "danger")
      onClose()
    } finally {
      setLoading(false)
    }
  }

  return createPortal(
    <div className={styles["modal-container"]}>
      <Modal show={true} closeListener={onClose} includeCloseX={true}>
        <h2 className="mt0 mb0">Switch to</h2>
        <div className="success-modal-badge">{parse(lockupLogoSvg() + planNameBadge(planName))}</div>
        <p>
          Your subscription will be switched to the {planName} plan
          {priceLine && `, ${priceLine}`}.
        </p>
        <div className="action-buttons-row">
          <button className="button-tertiary button-outlined" onClick={onClose}>
            Nevermind
          </button>
          <button className="button-tertiary" disabled={loading} onClick={handleSwitch}>
            {loading ? "Switching..." : cta}
          </button>
        </div>
      </Modal>
    </div>,
    document.body,
  )
}

export default CreditsPlanChangeModal
